import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Box,
  Typography,
  Slider,
  ButtonProps
} from "@mui/material";
import { ThemeContext } from "../../context/themeProviderContext";
import { ChromePicker } from 'react-color';
import UpdateSabitleAPI from "../../apis/UpdateSabitleAPI";

interface ColorPickerProps {
  onPrimaryColorChange: (color: any) => void;
  onSecondaryColorChange: (color: any) => void;
  onButtonVariantChange: (event: any) => void;
  buttonVariant: ButtonProps['variant'];
}

const ColorPicker: React.FC<ColorPickerProps> = ({
  onPrimaryColorChange,
  onSecondaryColorChange,
  onButtonVariantChange,
  buttonVariant
}) => {
  const { primaryColor, secondaryColor, thirdColor, fourthColor, errorColor, fontSize, setFontSize, setThirdColor, setFourthColor, setErrorColor }:any = useContext(ThemeContext);
  const [tempPrimaryColor, setTempPrimaryColor] = useState(primaryColor);
  const [tempSecondaryColor, setTempSecondaryColor] = useState(secondaryColor);
  const [tempThirdColor, setTempThirdColor] = useState(thirdColor);
  const [tempFourthColor, setTempFourthColor] = useState(fourthColor);
  const [tempErrorColor, setTempErrorColor] = useState(errorColor);
  const [tempButtonVariant, setTempButtonVariant] = useState(buttonVariant);
  const [tempFontSize, setTempFontSize] = useState(fontSize);

  const [isChanged, setIsChanged] = useState(false); // Değişiklik kontrolü için yeni state
  // useEffect ile değişiklik kontrolü
  useEffect(() => {
    const isModified =
      tempPrimaryColor !== primaryColor ||
      tempSecondaryColor !== secondaryColor ||
      tempThirdColor !== thirdColor ||
      tempFourthColor !== fourthColor ||
      tempErrorColor !== errorColor ||
      tempButtonVariant !== buttonVariant ||
      tempFontSize !== fontSize;

    setIsChanged(isModified); // Eğer herhangi bir değişiklik varsa buton aktif olur
  }, [
    tempPrimaryColor,
    tempSecondaryColor,
    tempThirdColor,
    tempFourthColor,
    tempErrorColor,
    tempButtonVariant,
    tempFontSize,
    primaryColor,
    secondaryColor,
    thirdColor,
    fourthColor,
    errorColor,
    buttonVariant,
    fontSize
  ]);
  const handlePrimaryColorChange = (color: any) => {
    setTempPrimaryColor(color.hex);
  };

  const handleSecondaryColorChange = (color: any) => {
    setTempSecondaryColor(color.hex);
  };

  const handleThirdColorChange = (color: any) => {
    setTempThirdColor(color.hex);
  };

  const handleFourthColorChange = (color: any) => {
    setTempFourthColor(color.hex);
  };

  const handleErrorColorChange = (color: any) => {
    setTempErrorColor(color.hex);
  };

  const handleButtonVariantChange = (event: any) => {
    setTempButtonVariant(event.target.value);
  };

  const handleFontSizeChange = (event: any, newValue: number | number[]) => {
    setTempFontSize(newValue as number);
  };



  const handleSaveChanges = async () => {
    try {
      // Adım 1: UI'yi güncelle
      onPrimaryColorChange({ target: { value: tempPrimaryColor } });
      onSecondaryColorChange({ target: { value: tempSecondaryColor } });
      setThirdColor(tempThirdColor);
      setFourthColor(tempFourthColor);
      setErrorColor(tempErrorColor);
      onButtonVariantChange({ target: { value: tempButtonVariant } });
      setFontSize(tempFontSize);
  
      // Adım 2: API'ye veri gönder
      const response = await UpdateSabitleAPI.postUpdateSabitler(
        1, // kurumId
        null, // gencisBorkontrolEh
        null, // basvuruAlindiDurumKodu
        tempPrimaryColor, // primaryColor
        tempSecondaryColor, // secondaryColor
        tempThirdColor, // thirdColor
        tempFourthColor, // fourthColor
        tempErrorColor, // errorColor
        tempButtonVariant, // buttonVariant
        null, // themeMode
        tempFontSize, // fontSize
        null, // kwMetni
        null, // sicilOlusturma
        null // kullaniciKodu
      );
  
      // Adım 3: API'den başarılı yanıt alındığında localStorage'a kaydet
      if (response) {
        localStorage.setItem("primaryColor", tempPrimaryColor);
        localStorage.setItem("secondaryColor", tempSecondaryColor);
        localStorage.setItem("thirdColor", tempThirdColor);
        localStorage.setItem("fourthColor", tempFourthColor);
        localStorage.setItem("errorColor", tempErrorColor);
        localStorage.setItem("buttonVariant", tempButtonVariant!);
        localStorage.setItem("fontSize", tempFontSize.toString());
  
        console.log('Değerler başarıyla güncellendi ve localStorage\'a kaydedildi');
      }
    } catch (error) {
      console.error('API çağrısı sırasında bir hata oluştu:', error);
    }
  };
  
  
  return (
    <Box 
      sx={{ 
        my: 2, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        gap: 2, 
        width: '100%', 
        px: 4,
        boxSizing: 'border-box'
      }}
    >
      <FormControl fullWidth variant="outlined">
        <Typography variant="h6" align="center">Birincil Renk</Typography>
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            mt: 1
          }}
        >
          <ChromePicker
            color={tempPrimaryColor}
            
            onChange={handlePrimaryColorChange}
          />
        </Box>
      </FormControl>
      <FormControl fullWidth variant="outlined">
        <Typography variant="h6" align="center">İkincil Renk</Typography>
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            mt: 1
          }}
        >
          <ChromePicker
            color={tempSecondaryColor}
            onChange={handleSecondaryColorChange}
          />
        </Box>
      </FormControl>
      <FormControl fullWidth variant="outlined">
        <Typography variant="h6" align="center">Üçüncül Renk</Typography>
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            mt: 1
          }}
        >
          <ChromePicker
            color={tempThirdColor}
            onChange={handleThirdColorChange}
          />
        </Box>
      </FormControl>
      <FormControl fullWidth variant="outlined">
        <Typography variant="h6" align="center">Dördüncül Renk</Typography>
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            mt: 1
          }}
        >
          <ChromePicker
            color={tempFourthColor}
            onChange={handleFourthColorChange}
          />
        </Box>
      </FormControl>
      <FormControl fullWidth variant="outlined">
        <Typography variant="h6" align="center">Hata Rengi</Typography>
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            mt: 1
          }}
        >
          <ChromePicker
            color={tempErrorColor}
            onChange={handleErrorColorChange}
          />
        </Box>
      </FormControl>
      <FormControl className="mt-3" fullWidth variant="outlined">
        <InputLabel id="button-variant-label">Buton Türü</InputLabel>
        <Select
          size="small"
          labelId="button-variant-label"
          value={tempButtonVariant}
          onChange={handleButtonVariantChange}
          label="Button Variant"
        >
          <MenuItem value="contained">Contained</MenuItem>
          <MenuItem value="outlined">Outlined</MenuItem>
          <MenuItem value="text">Text</MenuItem>
        </Select>
      </FormControl>
      <FormControl fullWidth variant="outlined">
        <Typography variant="h6" align="center">Yazı Boyutu</Typography>
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            mt: 1
          }}
        >
          <Slider
            value={tempFontSize}
            onChange={handleFontSizeChange}
            aria-labelledby="font-size-slider"
            min={0.5}
            max={3}
            step={0.1}
            valueLabelDisplay="auto"
          />
        </Box>
      </FormControl>
      <Button size="small" fullWidth variant="contained" onClick={handleSaveChanges}
              disabled={!isChanged} // Buton yalnızca değişiklik olduğunda aktif
      >
        Kaydet
      </Button>
    </Box>
  );
};

export default ColorPicker;
